export default __webpack_public_path__ + "static/reauth_scale-6b4b100356ce46e097f7da799ca8ad46.svg";